import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AutofocusModule } from '®shared/autofocus';
import { AvatarsModule } from '®shared/avatars';
import { InlineNoteModule } from '®shared/inline-note';
import { InlineNoteEditorModule } from '®shared/inline-note';

import { StudyNoteComponent } from './study-note.component';

@NgModule({
  imports: [
    AutofocusModule,
    AvatarsModule,
    CommonModule,
    FormsModule,
    InlineNoteModule,
    InlineNoteEditorModule,
  ],
  declarations: [StudyNoteComponent],
  exports: [StudyNoteComponent],
})
export class StudyNoteModule {}
